import { GetFolderDetailsResponse } from "@mg/schemas/src/christo/catalyst";
import { Grid } from "@radix-ui/themes";

import ChatPane from "./ChatPane";
import { WorkflowProvider } from "./context";
import PreviewPane from "./PreviewPane";

type WorkflowProps = {
  /** An optional folder to load to pre-fill the page with. */
  folder: GetFolderDetailsResponse | null;
  /** An optional folderId to load and pre-fill the page with. */
  folderId: string | undefined;
  /** An optional personas array to tell the AI how to review a set of assets.
   * */
  personas: ("brand" | "copy" | "legal")[] | undefined;
};

export default function Workflow({
  folder,
  folderId,
  personas,
}: WorkflowProps) {
  return (
    <WorkflowProvider folder={folder} folderId={folderId} personas={personas}>
      <Grid gap="4" height="100vh" className="auto-rows-[auto_1fr]">
        {/* Make room for the upload status component */}

        <Grid columns={{ sm: "2" }} px="4" pb="4" gap="4">
          <ChatPane />

          <PreviewPane />
        </Grid>
      </Grid>
    </WorkflowProvider>
  );
}
